import React, { useEffect, useMemo, useState } from "react";
import { FieldArray, Form, Formik } from "formik";
import { useSession } from "../../authentications/SessionContext";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import { handleResponse } from "../../utilities/handleResponse";
import FormikInput from "../Formik/FormikInput";
import { write } from "../../DataApi/write";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { primaryColor } from "../../utilities/colors";
import { newTranslationFormValidationSchema } from "../../utilities/Validation Schema/NewBrandFormValidationSchema";
import { enqueueSnackbar } from "notistack";

const SetTranslation = ({ handleCloseModal, data = {} }) => {
  const { sessionInfo = true } = useSession();
  const { company_id, context } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  const [isLoading, setIsLoading] = useState(true);

  const [disableInputs, setDisableInputs] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const { isSubmitting, setIsSubmitting, FormikSubmitButtons } =
    useFormikSubmitButton();

  const [formData, setFormData] = useState({ translation: data });
  const modelName = "ir.translation";

  const getPayload = (payload) => {
    return payload;
  };
  const handleAddTranslation = async (values) => {
    // console.log("write api", values);
    const newChanges = {};
    const oldPayload = getPayload(formData);
    const newPayload = getPayload(values);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) !== JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    // console.log("newChanges", newChanges);
    let response = await write({
      id: newChanges?.translation?.[0]?.id,
      change: { value: newChanges?.translation?.[0]?.value },
      company_id,
      context,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      enqueueSnackbar("Translation Created Successfully", {
        variant: "success",
      });
      return;
      handleCloseModal();
      // refetchData();
    }
    return response;
  };

  const handleSubmitForm = async (...args) => {
    const [values, { setFieldError, setFieldTouched }] = args;

    setIsSubmitting(true);
    let response = {};
    let successMessage = "Translation Created Successfully";
    response = await handleAddTranslation(...args);

    setIsSubmitting(false);
  };

  useEffect(() => {
    // setFormData({
    //   ...response,
    //   name: response?.name,
    // });
    setIsLoading(false);
  }, []);

  return (
    <>
      <ConfirmationModal />
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={newTranslationFormValidationSchema}
        onSubmit={handleSubmitForm}
      >
        {({
          values,
          setFieldValue,
          validateForm,
          setErrors,
          errors,
          setFieldTouched,
        }) => (
          <Form>
            {/* {console.log(errors, "errors")} */}
            <div
              className="container mb-4"
              style={{ width: "1000px", padding: "10px" }}
            >
              <FormContainer className="row g-3">
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="col">
                    <h3
                      className="me-2 mb-2 "
                      style={{
                        fontFamily: "Inter",
                        color: "#323B4B",
                        fontWeight: 600,
                      }}
                    >
                      Set Translations
                    </h3>
                  </div>
                </div>
                <LoaderWrapper
                  isLoading={isLoading}
                  height="70vh"
                  width="800px"
                >
                  <div className="d-flex justify-content-between align-items-center col-12 gap-5">
                    <div className="col-12 row">
                      <FieldArray
                        name="translation"
                        render={({ form, name }) => {
                          // console.log("name", name, form, data);
                          return form.values?.[name]?.map((input, index) => (
                            <div className="col-md-6" key={`${name}-${index}`}>
                              <FormikInput
                                name={`${name}.${index}.value`}
                                label={input.label}
                              />
                            </div>
                          ));
                        }}
                      />
                    </div>
                  </div>

                  {/* <ErrorFocus /> */}

                  <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                </LoaderWrapper>
              </FormContainer>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SetTranslation;
